var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _c(
        "img",
        _vm._g(
          _vm._b(
            {
              class: _vm.imgClass,
              attrs: { src: `static/images/icons/${_vm.icon}.svg` },
            },
            "img",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      ),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }